import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000, // 60 seconds for blockchain transactions
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Upload file to IPFS
 */
export const uploadToIPFS = async (file) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await api.post('/upload-to-ipfs', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};

/**
 * Submit invoice to blockchain
 */
export const submitInvoice = async (invoiceData) => {
  const response = await api.post('/submit-invoice', invoiceData);
  return response.data;
};

/**
 * Search invoice by invoice number
 */
export const searchInvoice = async (invoiceNumber) => {
  const response = await api.get('/search-invoice', {
    params: { invoiceNumber },
  });
  return response.data;
};

/**
 * Search invoices by date (DD-MM-YYYY)
 */
export const searchByDate = async (date) => {
  const response = await api.get('/search-by-date', {
    params: { date },
  });
  return response.data;
};

/**
 * Get all records
 */
export const getAllRecords = async () => {
  const response = await api.get('/get-all-records');
  return response.data;
};

/**
 * Get IPFS gateway URL
 */
export const getIPFSGatewayURL = async (hash) => {
  const response = await api.get('/ipfs-gateway-url', {
    params: { hash },
  });
  return response.data;
};

/**
 * Download file from IPFS
 */
export const downloadFromIPFS = (hash) => {
  // Clean hash if it has ipfs:// prefix
  const cleanHash = hash.replace('ipfs://', '');
  return `${API_BASE_URL}/download-from-ipfs?hash=${cleanHash}`;
};

/**
 * Get wallet info (for debugging)
 */
export const getWalletInfo = async () => {
  const response = await api.get('/wallet-info');
  return response.data;
};

/**
 * Health check
 */
export const healthCheck = async () => {
  const response = await api.get('/health');
  return response.data;
};

export default api;
